// Conversão OKLCH → sRGB para os dithers em <canvas> (item B.4): ImageData só
// aceita canais RGB numéricos, então os componentes que desenham o grão Bayer
// (Avatar, WorkerProfileCard) não conseguem ler os tokens CSS --agent/*. Esta
// função replica em JS a mesma cor que oklch(L C H) produz no CSS, mantendo o
// avatar e os acentos do agente na mesma cor em qualquer superfície.
//
// Matrizes OKLab de Björn Ottosson (mesmas da spec CSS Color 4). Fora do gamut
// sRGB fazemos clamp por canal em vez do gamut mapping da spec — para os C
// baixos usados aqui (≤ 0.18) a diferença é imperceptível.

export type Rgb = [number, number, number]

/** Converte oklch(l c h) em [r, g, b] 0–255 (sRGB). `h` em graus. */
export function oklchToRgb(l: number, c: number, h: number): Rgb {
  const hr = (h * Math.PI) / 180
  const a = c * Math.cos(hr)
  const b = c * Math.sin(hr)

  // OKLab → LMS (cúbico) → sRGB linear
  const l3 = (l + 0.3963377774 * a + 0.2158037573 * b) ** 3
  const m3 = (l - 0.1055613458 * a - 0.0638541728 * b) ** 3
  const s3 = (l - 0.0894841775 * a - 1.291485548 * b) ** 3
  const lr = 4.0767416621 * l3 - 3.3077115913 * m3 + 0.2309699292 * s3
  const lg = -1.2684380046 * l3 + 2.6097574011 * m3 - 0.3413193965 * s3
  const lb = -0.0041960863 * l3 - 0.7034186147 * m3 + 1.707614701 * s3

  const encode = (channel: number): number => {
    const v = channel <= 0.0031308
      ? 12.92 * channel
      : 1.055 * Math.pow(Math.max(channel, 0), 1 / 2.4) - 0.055
    return Math.round(Math.min(1, Math.max(0, v)) * 255)
  }

  return [encode(lr), encode(lg), encode(lb)]
}
